import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatList, MatListItem, MatListItemLine } from '@angular/material/list';

import type { SuppressionList } from '@ninety/platform/models/helpful/suppression-list.interface';
import { HelpfulService } from '@ninety/platform/services';
import { TerraSearchInputModule, TerraIconModule } from '@ninety/terra';
import {
  ButtonComponent,
  CardComponent,
  CardHeaderComponent,
  EmailAddressSearchPipe,
  NinetyTooltipDirective,
  LegacyAlertComponent as AlertComponent,
} from '@ninety/ui/core';

@Component({
  selector: 'ninety-email-suppression-list',
  templateUrl: './email-suppression-list.component.html',
  styleUrls: ['../_shared/tab-styles.scss', './email-suppression-list.component.scss'],
  standalone: true,
  imports: [
    CardComponent,
    CardHeaderComponent,
    TerraSearchInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatList,
    MatListItem,
    MatListItemLine,
    ButtonComponent,
    NinetyTooltipDirective,
    TerraIconModule,
    AlertComponent,
    EmailAddressSearchPipe,
  ],
})
export class EmailSuppressionListComponent {
  private readonly helpfulService = inject(HelpfulService);

  suppressionList: SuppressionList[];
  suppressionListSearch = new FormControl('');

  searchSuppressionList() {
    this.suppressionList = null;
    this.helpfulService
      .getSuppressionList(this.suppressionListSearch.value)
      .subscribe(list => (this.suppressionList = list));
  }

  removeFromSuppressionList(email: string) {
    this.helpfulService.removeFromSuppressionList(email).subscribe(() => {
      this.suppressionList = this.suppressionList.filter(({ EmailAddress }) => EmailAddress !== email);
    });
  }
}
